export default "__VITE_ASSET__CTU7F9Bk__"